import { render, staticRenderFns } from "./Match.vue?vue&type=template&id=01b3593f&scoped=true"
import script from "./Match.vue?vue&type=script&lang=js"
export * from "./Match.vue?vue&type=script&lang=js"
import style0 from "./Match.vue?vue&type=style&index=0&id=01b3593f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b3593f",
  null
  
)

export default component.exports